// extracted by mini-css-extract-plugin
module.exports = {"root":"cA4ag"};